import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ spacing, colors, shadow }: Theme) => createStyles({
  listbox: {
    margin: spacing(1),
    background: colors.base.white,
    '& [aria-selected="true"]': {
      backgroundColor: colors.base.white,
    },
  },
  popupIndicator: {
    '&:hover': {
      background: 'none',
    },
  },
  endAdornment: {
    top: `calc(50% - ${spacing(4) - 3}px)`,
    right: spacing(2),
  },
  clearIndicator: {
    marginRight: spacing(2),
    '&:hover': {
      background: 'none',
    },
  },
  popupIndicatorOpen: {
    transform: 'none',

    '& svg': {
      transform: 'rotate(180deg)',
    },
  },
  popper: {
    zIndex: 10005,
  },
  paper: {
    background: colors.base.white,
    boxShadow: shadow.dropShadow200,
    '& ul': {
      background: colors.base.white,
      margin: 0,
      '& li.MuiAutocomplete-option': {
        padding: 0,
      },
      '& .MuiAutocomplete-option[data-focus="true"]:hover': {
        backgroundColor: colors.pageElements.dropdownMenuOption.hovered.background,
      },
    },
  },
  inputRoot: {
    gap: spacing(1),
    '& .MuiChip-root': {
      maxWidth: '100%',
    },
    '& .MuiChip-root.Mui-disabled': {
      opacity: 'unset',
    },
    '&&&': {
      paddingRight: `${spacing(15) + 2}px`,
      paddingBottom: spacing(2),
      '& .MuiAutocomplete-input:first-child': {
        padding: 0,
      },
    },
  },
  small: {
    '&&&': {
      paddingBottom: spacing(1),
    },
    '& $endAdornment': {
      top: 0,
    },
  },
  input: {
    textOverflow: 'initial',
  },
  menuItem: {
    '&&&': {
      whiteSpace: 'normal',
    },
    display: 'flex',
    justifyContent: 'space-between',
    gap: spacing(1),
    '& .MuiSvgIcon-root': {
      position: 'unset',
    },
  },
  menuItemText: {
    whiteSpace: 'normal',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

export default styles;
